import * as THREE from 'three';

export default {
    attributes: {
        particleFrameOffset: {
            type: 'float'
        }
    },
    varyings: {
        vTexOffset: {
            type: 'vec2'
        }
    },
    uniforms: {
        frameCount: {
            type: 'vec2',
            value: new THREE.Vector2( 4, 4 )
        },
        uTime: {
            type: 'float',
            value: 0
        }
    },
    vertex: {
        code: `
        float t = floor(uTime * 24. );
        vTexOffset = vec2(0.);
        vTexOffset.x = mod( particleFrameOffset + t  , frameCount.x )/ frameCount.x ;
        vTexOffset.y = (frameCount.y-1.)/frameCount.y + floor( (particleFrameOffset  + t  )/ frameCount.x )/ frameCount.y ;
 
        `
    },
    fragment: {
        code: `

        vec2 uvI = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
       
             
        // scale UV to sprite frame dimensions
        uvI.x *= 1. / frameCount.x;
        uvI.y *= 1. / frameCount.y;

        vec2 spriteUV = uvI;

        spriteUV += vTexOffset ;
        

        vec4 mapSprite = texture2D( map, spriteUV );
        diffuseColor = mapTexelToLinear( mapSprite );

        `
    },
  
}